module.exports = __webpack_public_path__ + "static/media/close.358cad35.svg";